<div>
  @if (logs.length > 0) {
    <div class="headers">
      <div class="search-section-wrapper">
        <app-search-input
          [placeholder]="'Search CDFI...'"
          [(searchQuery)]="searchText"
          (searchQueryChange)="onSearchQueryChange($event)"
        ></app-search-input>
      </div>
      <div class="page-size">
        <app-page-size
          [pageSize]="pageSize"
          [selectId]="'deeproots-links'"
          (pageSizeChanged)="onPageSizeChange($event)"
        ></app-page-size>
      </div>
    </div>
  } @else {
    <div class="headers">
      <div class="search-section-wrapper">
        <app-search-input
          [placeholder]="'Search CDFI...'"
          [(searchQuery)]="searchText"
          (searchQueryChange)="onSearchQueryChange($event)"
        ></app-search-input>
      </div>
    </div>
  }

  <app-table
    [columns]="tableColumns"
    [data]="logs"
    [loading]="loading"
    [noResultsMessage]="'No link submissions found.'"
  >
    <ng-template let-log>
      <tr>
        <td>{{ log.display_name }}</td>
        <td>{{ log.submissions }}</td>
        <td>
          <div class="action-icons">
            <a href="javascript:void(0)" (click)="viewDetails(log)"> View </a>
          </div>
        </td>
      </tr>
    </ng-template>
  </app-table>

  @if (logs.length > 0) {
    <app-pagination
      [currentPage]="currentPage"
      [pageSize]="pageSize"
      [totalItems]="totalLogs"
      (pageChanged)="onPageChange($event)"
    ></app-pagination>
  }
</div>
